module.exports = __webpack_public_path__ + "static/media/google-play-icon.50285b70.svg";